import React, { useState } from "react";
import { useTheme } from "../../App";
import styles from "./OnboardingUseCase.module.css";
import diffusionIconLight from "../../assets/diffusion_light.svg";
import diffusionIconDark from "../../assets/diffusion_dark.svg";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase/config";
import { useAuth } from "../../components/Auth/AuthProvider"; // Ensure user is destructured

const roleOptions = [
  "Mechanical engineering",
  "Electrical engineering",
  "Civil engineering",
  "Architectural design",
  "Industrial design",
  "Manufacturing/Production",
  "Structural engineering",
  "Student",
  "Educator",
  "Other",
];

const OnboardingRole: React.FC = () => {
  const { user, updateUserProfile } = useAuth(); // Make sure 'user' is destructured
  const { theme, setTheme } = useTheme();
  const getActualTheme = (): "light" | "dark" => {
    if (theme === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return theme as "light" | "dark";
  };
  const actualTheme = getActualTheme();
  const [selectedRole, setSelectedRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const diffusionIcon =
    actualTheme === "dark" ? diffusionIconDark : diffusionIconLight;

  // NEW CODE

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedRole || loading) return;

    setLoading(true);

    try {
      // 1. Save Role AND Complete Onboarding
      await updateUserProfile({
        role: selectedRole,
        onboardingCompleted: true, // Finish immediately
      });

      // 2. Add to SendGrid (Logic moved from Credits page)
      if (user) {
        try {
          const addToSendGrid = httpsCallable(functions, "addUserToSendGrid");
          await addToSendGrid({
            email: user.email,
            firstName: user.displayName?.split(" ")[0] || "",
            lastName: user.displayName?.split(" ").slice(1).join(" ") || "",
          });
        } catch (err) {
          // console.error("SendGrid error ignored:", err);
        }
      }

      // 3. Redirect to App
      window.history.pushState({}, "", "/new");
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch (error) {
      console.error("Error saving role:", error);
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button
          className={styles.logoButton}
          onClick={() => (window.location.href = "/")}
          aria-label="Go to home"
        >
          <img src={diffusionIcon} alt="Noah" className={styles.logo} />
        </button>
      </div>

      <div className={styles.scrollableContent}>
        <div className={styles.content}>
          <h1 className={styles.title}>Which role best describes you?</h1>
          <p className={styles.description}>
            If you're multi-talented, pick what you do most often.
          </p>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.optionsContainer}>
              {roleOptions.map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => setSelectedRole(option)}
                  className={`${styles.optionButton} ${
                    selectedRole === option ? styles.optionButtonSelected : ""
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>

            <div className={styles.buttonContainer}>
              <button
                type="submit"
                disabled={!selectedRole || loading}
                className={styles.submitButton}
              >
                Finish
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OnboardingRole;
